<template>
  <v-flex>
    <div class="elevation-3">
      <div class="tableHeader">
        <!--MODAL-->
        <v-dialog persistent v-model="modal" max-width="500px">
          <v-btn slot="activator" color="#f8ac4a" dark class="mb-2">
            <v-icon class="buttonIconText" color="white">playlist_add</v-icon>
            Nova {{ name }}</v-btn
          >
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-form ref="form" v-on:submit.prevent>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md12>
                      <label class="label-modal">Nome</label>
                      <v-text-field
                        color="#f8ac4a"
                        :rules="defaultRules"
                        v-model="editedItem.nome"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <label class="label-modal">Username</label>
                      <v-text-field
                        color="#f8ac4a"
                        :rules="defaultRules"
                        v-model="editedItem.username"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <label class="label-modal">Email</label>
                      <v-text-field
                        color="#f8ac4a"
                        :rules="defaultRules"
                        v-model="editedItem.email"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <label class="label-modal">Entidade ou Associada?</label>
                      <v-autocomplete
                        color="#f8ac4a"
                        :items="classes"
                        v-model="editedItem.associada"
                        item-text="nome"
                        item-value="id_classe"
                        :rules="defaultRules"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm12 md12 v-if="editedItem.associada == 2">
                      <label class="label-modal">Entidade associada?</label>
                      <v-autocomplete
                        color="#f8ac4a"
                        :items="associadas"
                        multiple
                        v-model="editedItem.associadas"
                        item-text="nome"
                        item-value="id_associada"
                        :rules="defaultRules"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <label class="label-modal">Tipo instituição</label>
                      <v-autocomplete
                        color="#f8ac4a"
                        :items="tipos"
                        v-model="editedItem.publico"
                        item-text="nome"
                        item-value="id_tipo"
                        :rules="defaultRules"
                      ></v-autocomplete>
                    </v-flex>

                    <v-flex xs12 sm12 md12>
                      <label class="label-modal">Fins lucrativos</label>
                      <v-autocomplete
                        color="#f8ac4a"
                        :items="fins_lucrativos"
                        v-model="editedItem.fins_lucrativos"
                      ></v-autocomplete>
                    </v-flex>

                    <v-flex
                      xs12
                      sm12
                      md12
                      v-if="editedItem.fins_lucrativos == 'Sem fins lucrativos'"
                    >
                      <label class="label-modal">Tipo</label>
                      <v-autocomplete
                        color="#f8ac4a"
                        :items="tipo_fins_lucrativos"
                        v-model="editedItem.tipo_fins_lucrativos"
                      ></v-autocomplete>
                    </v-flex>

                    <v-flex xs12 sm12 md12>
                      <label class="label-modal"
                        >A entidade trabalha formalmente em setores diretamente
                        relacionados com a educação?</label
                      >
                      <v-autocomplete
                        color="#f8ac4a"
                        :items="['Sim', 'Não']"
                        v-model="editedItem.trabalha_educacao"
                      ></v-autocomplete>
                    </v-flex>

                    <v-flex xs12 sm12 md12>
                      <label class="label-modal"
                        >A entidade reconhece formalmente a Educação para o
                        Desenvolvimento em documentos estratégicos e/ou
                        operacionais?</label
                      >
                      <v-autocomplete
                        color="#f8ac4a"
                        :items="['Sim', 'Não']"
                        v-model="editedItem.trabalha_estrategicos"
                      ></v-autocomplete>
                    </v-flex>

                    <v-flex xs12 sm12 md12>
                      <label class="label-modal"
                        >Selecione o distrito onde a entidade desempenha uma
                        intervenção mais ativa</label
                      >
                      <v-autocomplete
                        color="#f8ac4a"
                        :items="distritos"
                        item-text="name"
                        item-value="name"
                        v-model="editedItem.distrito"
                      ></v-autocomplete>
                    </v-flex>

                    <v-flex v-if="editedIndex == -1" xs12 sm12 md12>
                      <label class="label-modal">Password</label>
                      <v-text-field
                        color="#f8ac4a"
                        type="password"
                        :rules="defaultRules"
                        v-model="editedItem.password"
                        append-icon="cached"
                        @click:append="gerarPassword()"
                      ></v-text-field>
                    </v-flex>
                    <v-flex v-if="editedIndex == -1" xs12 sm12 md12>
                      <label class="label-modal">Confirmar password</label>
                      <v-text-field
                        color="#f8ac4a"
                        :rules="pwdRules"
                        v-model="cpwd"
                        :type="show ? 'text' : 'password'"
                        @click:append="show = !show"
                        :append-icon="!show ? 'visibility' : 'visibility_off'"
                      ></v-text-field>
                    </v-flex>
                    <v-flex v-if="editedIndex > -1" xs12 sm12 md12>
                      <label class="label-modal">Ativo?</label>
                      <v-checkbox
                        color="#f8ac4a"
                        v-model="editedItem.ativo"
                      ></v-checkbox>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#f8ac4a" flat @click.native="close"
                  >Cancelar</v-btn
                >
                <v-btn color="#f8ac4a" flat @click.native="save">Guardar</v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>

        <v-text-field
          color="#f8ac4a"
          class="searchTable"
          v-model="search"
          append-icon="search"
          label="Pesquisa"
          single-line
          hide-details
        ></v-text-field>
      </div>

      <v-dialog persistent v-model="deleteM" max-width="390">
        <v-card>
          <v-card-title class="headline" style="margin-left: 0px !important"
            >Apagar {{ name }}</v-card-title
          >
          <v-card-text>De certeza que quer apagar este {{ name }}?</v-card-text>
          <v-card-actions style="margin-top: 0px !important">
            <v-spacer></v-spacer>
            <v-btn color="#f8ac4a" flat="flat" @click.native="close"
              >Cancelar</v-btn
            >
            <v-btn color="#f8ac4a" flat="flat" @click.native="save"
              >Apagar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="modal_setores" max-width="390">
        <v-card>
          <v-card-title class="headline" style="margin-left: 0px !important"
            >Setores</v-card-title
          >
          <v-card-text>
            <v-flex xs12 sm12 md12>
              <label class="label-modal"
                >Selecione o(s) setor(es) de atividade da entidade</label
              >
              <v-autocomplete
                color="#f8ac4a"
                :items="getSectores"
                multiple
                v-model="setores"
                item-text="nome"
                item-value="id_setor"
              ></v-autocomplete>
            </v-flex>
          </v-card-text>
          <v-card-actions style="margin-top: 0px !important">
            <v-spacer></v-spacer>
            <v-btn
              color="#f8ac4a"
              flat="flat"
              @click.native="modal_setores = false"
              >Cancelar</v-btn
            >
            <v-btn color="#f8ac4a" flat="flat" @click.native="saveSetores"
              >Guardar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="novaPwd" max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">Nova password</span>
          </v-card-title>
          <v-form ref="formPwd">
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm12 md12>
                    <label class="label-modal">Password</label>
                    <v-text-field
                      color="#f8ac4a"
                      type="password"
                      :rules="defaultRules"
                      v-model="editedItem.password"
                      append-icon="cached"
                      @click:append="gerarPassword()"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <label class="label-modal">Confirmar password</label>
                    <v-text-field
                      color="#f8ac4a"
                      :rules="pwdRules"
                      v-model="cpwd"
                      :type="show ? 'text' : 'password'"
                      @click:append="show = !show"
                      :append-icon="!show ? 'visibility' : 'visibility_off'"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="#f8ac4a" flat @click.native="novaPwd = false"
                >Cancelar</v-btn
              >
              <v-btn color="#f8ac4a" flat @click.native="updatePwd"
                >Guardar</v-btn
              >
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>

      <v-data-table
        :headers="headers"
        :items="DATA"
        :search="search"
        :loading="loading"
        item-key="id"
        :disable-initial-sort="true"
        :rows-per-page-items="[10, 25, 50, { text: 'Todos', value: -1 }]"
        rows-per-page-text="Itens por página:"
      >
        <template slot="items" slot-scope="props">
          <td @click="editItem(props.item, true)" class="textLeft">
            {{ props.item.id_instituicao }}
          </td>
          <td @click="editItem(props.item, true)" class="textLeft">
            {{ props.item.nome }}
          </td>
          <td @click="editItem(props.item, true)" class="textCenter">
            {{ props.item.username }}
          </td>
          <td @click="editItem(props.item, true)" class="textCenter">
            {{ props.item.email }}
          </td>
          <td @click="editItem(props.item, true)" style="text-align: center">
            <span
              v-if="props.item.ativo"
              style="
                background-color: green;
                height: 10px;
                width: 10px;
                border-radius: 50px;
                position: absolute;
              "
            ></span
            ><span
              v-else
              style="
                background-color: red;
                height: 10px;
                width: 10px;
                border-radius: 50px;
                position: absolute;
              "
            ></span>
          </td>
          <td class="px-0 textTable textCenter">
            <v-btn icon class="mx-0" @click="viewSetores(props.item, true)">
              <v-icon color="light-green darken-1">account_balance</v-icon>
            </v-btn>

            <v-btn icon class="mx-0" @click="editItem(props.item, true)">
              <v-icon color="light-green darken-1">edit</v-icon>
            </v-btn>
            <v-btn icon class="mx-0" @click="nPwd(props.item)">
              <v-icon color="amber">lock</v-icon>
            </v-btn>
            <v-btn icon class="mx-0" @click="editItem(props.item, false)">
              <v-icon color="red lighten-1">delete</v-icon>
            </v-btn>
          </td>
        </template>
        <template class="alertTable" slot="no-data">
          <v-alert :value="true" icon="warning">
            De momento não há nada a apresentar! :(
          </v-alert>
        </template>
      </v-data-table>
    </div>
  </v-flex>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { instance as axios } from "../../store/axios";
import distritos from "../../store/distritos.json";

const cName = {
  upper: "Instituição",
  lower: "a instituição!",
};

export default {
  data: () => ({
    tipo_fins_lucrativos: ["Associação", "Cooperativa", "Fundação"],
    fins_lucrativos: ["Sem fins lucrativos", "Com fins lucrativos"],
    setores: [],
    setores_id_instituicao: null,
    modal_setores: false,
    table: "instituicoes",
    name: "instituição",
    search: "",
    searchP: "",
    modal: false,
    deleteM: false,
    loading: true,
    show: false,
    searchC: "",
    novaPwd: false,
    headers: [
      {
        text: "#",
        align: "left",
        sortable: true,
        value: "id_instituicao",
      },
      {
        text: "Nome",
        align: "left",
        sortable: true,
        value: "nome",
      },
      {
        text: "Username",
        align: "center",
        sortable: true,
        value: "username",
      },
      {
        text: "E-mail",
        align: "center",
        sortable: true,
        value: "email",
      },
      {
        text: "Ativo",
        align: "center",
        sortable: true,
        value: "ativo",
      },
      {
        text: "Ações",
        value: "id",
        sortable: false,
        align: "center",
      },
    ],

    distritos: [],
    DATA: [],
    editedIndex: -1,
    cpwd: null,
    classes: [
      { id_classe: 1, nome: "Entidade signatária" },
      { id_classe: 2, nome: "Associada de entidade signatária" },
    ],
    associadas: [
      { id_associada: 1, nome: "PPONGD" },
      { id_associada: 2, nome: "ARIPESE" },
      { id_associada: 3, nome: "ANIMAR" },
    ],
    tipos: [
      { id_tipo: 1, nome: "Público" },
      { id_tipo: 2, nome: "Não Público" },
    ],
    editedItem: {
      id_instituicao: 0,
      nome: "",
      username: "",
      email: "",
      password: "",
      ativo: "",
      entidade: 0,
      associada: [],
      id_associada: 0,
      publico: 0,
      fins_lucrativos: "",
      tipo_fins_lucrativos: "",
      setor_publico: "",
    },
    defaultItem: {
      id_instituicao: 0,
      nome: "",
      username: "",
      email: "",
      password: "",
      ativo: "",
      entidade: 0,
      associada: [],
      id_associada: 0,
      publico: 0,
      fins_lucrativos: "",
      tipo_fins_lucrativos: "",
      setor_publico: "",
    },
    messages: {
      add: {
        success: cName.upper + " criada com sucesso!",
        error: "Ocorreu um erro ao criar " + cName.lower,
      },
      update: {
        success: cName.upper + " alterada com sucesso!",
        error: "Ocorreu um erro ao alterar " + cName.lower,
      },
      delete: {
        success: cName.upper + " eliminada com sucesso!",
        error: "Ocorreu um erro ao apagar " + cName.lower,
      },
      default: {
        sucesso: "Sucesso",
        error: "Ocorreu um erro!",
      },
    },
    defaultRules: null,
    pwdRules: null,
  }),

  computed: {
    ...mapGetters({
      getAll: "instituicoes/getAllInstituicoes",
      getSectores: "setores/getAll",
    }),
    formTitle() {
      return this.editedIndex === -1
        ? "Nova " + this.name
        : "Editar " + this.name;
    },
  },

  watch: {
    modal(val) {
      val || this.close();
    },
    deleteM(val) {
      val || this.close();
    },
    getAll(val) {
      this.initialize();
    },
    novaPwd(val) {
      val || this.close();
    },
  },

  created() {
    this.defaultRules = [(v) => !!v || this.$requiredField + ""];
    this.pwdRules = [
      (v) =>
        v == this.editedItem.password || "* As palavras-passe não coincidem!",
    ];
    this.initialize();
  },
  mounted() {
    this.distritos = distritos;
  },
  methods: {
    toast(type, message) {
      if (type == "success") {
        return iziToast.show({
          title: "SUCESSO",
          color: "green",
          timeout: this.$toastTimeout,
          message: message,
          position: this.$toastPosition,
        });
      } else {
        return iziToast.show({
          title: "AVISO",
          color: "red",
          timeout: this.$toastTimeout,
          message: message,
          position: this.$toastPosition,
        });
      }
    },

    updatePwd() {
      if (this.editedItem.password && this.editedItem.password == this.cpwd)
        this.$store
          .dispatch("session/update", {
            id: this.editedItem.id_instituicao,
            password: this.cpwd,
          })
          .then((res) => {
            if (res) {
              this.toast("success", "Password alterada com sucesso!");
              this.novaPwd = false;
            } else {
              this.toast("error", "Ocorreu um erro ao alterar a password!");
              this.novaPwd = false;
            }
          });
    },

    initialize() {
      this.loading = true;
      this.DATA = this.getAll;
      this.loading = false;
    },

    editItem(item, dialog) {
      this.editedIndex = this.DATA.indexOf(item);
      this.editedItem = Object.assign({}, item);

      if (this.editedItem.associada == 2 && this.editedItem.id_associada)
        this.editedItem.associadas = this.editedItem.id_associada
          .split(",")
          .map((el) => {
            return Number(el);
          });

      if (dialog) this.modal = true;
      else this.deleteM = true;
    },

    viewSetores(item, dialog) {
      let payload = {
        id_instituicao: item.id_instituicao,
      };
      this.setores_id_instituicao = item.id_instituicao;
      axios.post("/user/setores/" , { ...payload }).then((res) => {
        console.log(res);
        if (res.data.data != "Sem resultados") {
          this.setores = res.data.data;
        } else {
          this.setores = [];
        }
      });
      this.modal_setores = true;
    },
    saveSetores() {
      let payload = {
        id_instituicao: this.setores_id_instituicao,
        setores: this.setores,
      };

      axios.put("/user/update-setores/" , { ...payload }).then((res) => {
        this.toast("success", "dados alterados com sucesso!");
        this.modal_setores = false;
      });
    },
    nPwd(item) {
      this.$refs.formPwd.reset();

      this.editedIndex = this.DATA.indexOf(item);
      this.editedItem = Object.assign({}, item);

      this.novaPwd = true;
    },

    delete() {
      if (!this.editedItem.id_instituicao) return;

      this.$store
        .dispatch(this.table + "/delete", {
          id: this.editedItem.id_instituicao,
        })
        .then((res) => {
          if (res) {
            this.toast("success", this.messages.delete.success);
            this.initialize();
          } else this.toast("error", this.messages.delete.error);

          this.deleteM = false;
        });
    },

    close() {
      this.modal = this.deleteM = this.novaPwd = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;

        this.cpwd = null;

        this.$refs.form.reset();
        this.$refs.formPwd.reset();
      }, 110);
    },

    save() {
      if (this.deleteM) {
        this.delete();
        return;
      }

      if (!this.$refs.form.validate()) return;

      if (this.editedItem.associada == 2 && this.editedItem.id_associada)
        this.editedItem.associadas = this.editedItem.associadas.join(",");

      if (this.editedIndex == -1) {
        this.$store
          .dispatch(this.table + "/insert", {
            nome: this.editedItem.nome,
            username: this.editedItem.username,
            email: this.editedItem.email,
            password: this.editedItem.password,
            super: 0,
            associada: this.editedItem.associada,
            id_associada: this.editedItem.associadas,
            publico: this.editedItem.publico,
            fins_lucrativos: this.editedItem.fins_lucrativos,
            tipo_fins_lucrativos: this.editedItem.tipo_fins_lucrativos,
            setor_publico: this.editedItem.setor_publico,
            trabalha_educacao: this.editedItem.trabalha_educacao,
            trabalha_estrategicos: this.editedItem.trabalha_estrategicos,
            distrito: this.editedItem.distrito,
          })
          .then((res) => {
            if (res) {
              this.toast("success", this.messages.add.success);
              this.initialize();
            } else this.toast("error", this.messages.add.error);

            this.modal = false;
          });
      } else {
        this.$store
          .dispatch(this.table + "/update", {
            id: this.editedItem.id_instituicao,
            nome: this.editedItem.nome,
            username: this.editedItem.username,
            email: this.editedItem.email,
            ativo: this.editedItem.ativo ? 1 : 0,
            associada: this.editedItem.associada,
            id_associada: this.editedItem.associadas,
            publico: this.editedItem.publico,
            fins_lucrativos: this.editedItem.fins_lucrativos,
            tipo_fins_lucrativos: this.editedItem.tipo_fins_lucrativos,
            setor_publico: this.editedItem.setor_publico,
            trabalha_educacao: this.editedItem.trabalha_educacao,
            trabalha_estrategicos: this.editedItem.trabalha_estrategicos,
            distrito: this.editedItem.distrito,
          })
          .then((res) => {
            if (res) {
              this.toast("success", this.messages.update.success);
              this.initialize();
            } else this.toast("error", this.messages.update.error);

            this.modal = false;
          });
      }
    },

    gerarPassword() {
      this.editedItem.password = this.generatePassword();
      this.cpwd = this.editedItem.password;
    },

    generatePassword() {
      var length = 8,
        charset =
          "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
        retVal = "";
      for (var i = 0, n = charset.length; i < length; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n));
      }
      return retVal;
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/tables/Table_Instituicoes.vue